import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import { ExternalLink } from 'lucide-react';
import type LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';

interface ActivityFeedTrackingLinkProps {
  label: LangEnum;
  href: string;
  testId?: string;
}

const ActivityFeedTrackingLink = ({ label, href, testId }: ActivityFeedTrackingLinkProps) => {
  const { translate } = useTranslation();

  return (
    <Button
      variant="contained"
      color="secondary"
      size="small"
      href={href}
      testId={testId}
      endIcon={<Icon icon={ExternalLink} size="xs" />}
    >
      {translate(label)}
    </Button>
  );
};

ActivityFeedTrackingLink.displayName = 'ActivityFeedTrackingLink';
export default ActivityFeedTrackingLink;
